import React, { PropTypes } from 'react'
import moment from 'moment'
import { DATE_FORMAT } from '../../constants'

moment.locale('fr');

function Presse(props) {
	let img = null
	let cls = `article-tease article-tease--tall article-tease--presse`

	// Handle no-image case
	if (props.thumbnail) {
		img = <a href={ props.dl } className='article-tease__image' target='_blank'>
			<img className='img-responsive-grow' src={ props.thumbnail } alt={ props.chapo }/>
			<div className="article-tease__image-hover" />
		</a>

	} else {
		img = <a href={ props.dl } className='article-tease__image' target='_blank'>
			<div className="article-tease__image-hover" />
		</a>
		cls += ' article-tease--no-image'
	}

	return <div className={ cls } href={ props.permalink } target={ props.target }>
		{ img }
		<a href={ props.permalink } className='article-tease__content'>
			<div className="article-tease__date">{ moment(props.post_date).format(DATE_FORMAT) }</div>
			<h2 className='article-tease__title'>{ props.post_title }</h2>
			<div className='article-tease__body' dangerouslySetInnerHTML={{ __html: props.chapo }} />
			<div className='article-tease__readmore'>Lire la suite</div>
		</a>
	</div>
}


Presse.propTypes = {
	// Post (wp provided)
	permalink: PropTypes.string.isRequired,
	dl: PropTypes.string.isRequired,
	thumbnail: PropTypes.string,
	post_title: PropTypes.string.isRequired,
	chapo: PropTypes.string,
}

export { Presse as default }



// WEBPACK FOOTER //
// ./js/website/react_components/teasers/Presse.js